import { Card } from "@ui/card";
import { Skeleton } from "@ui/skeleton";

export const FullBookChaptersSkeleton = () => {
  const skeletonData: { id: string }[] = Array.from({ length: 10 }).map(
    (s, i) => {
      return {
        id: i + "",
      };
    }
  );

  const renderItems = () => {
    return skeletonData.map((s) => {
      return (
        <div
          className="flex h-[125px] w-[275px] flex-col justify-center gap-5 rounded-xl bg-white p-3 dark:bg-[#27272a]"
          key={s.id}
        >
          <div className="flex w-full items-center justify-between">
            <Skeleton
              className={`bg-[#f4f4f5]dark:bg-[#27272a] h-[28px] w-[30px] rounded-sm`}
            />
            <Skeleton
              className={`bg-[#f4f4f5]dark:bg-[#27272a] h-[28px] w-[30px] rounded-full`}
            />
          </div>
          <Skeleton
            className={`bg-[#f4f4f5]dark:bg-[#27272a] h-[100px] w-[90px] rounded-md`}
          />
          <Skeleton
            className={`bg-[#f4f4f5]dark:bg-[#27272a] h-[100px] w-[250px] rounded-md`}
          />
          <Skeleton
            className={`bg-[#f4f4f5]dark:bg-[#27272a] h-[100px] w-[250px] rounded-md`}
          />
        </div>
      );
    });
  };

  return (
    <div className="flex w-full flex-col items-start justify-start gap-4">
      {renderItems()}
    </div>
  );
};
